"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PfAttendancecategoryResource = exports.PfFileResource = exports.PfProjecthistoryResource = exports.PfInvoiceResource = exports.PfProjectResource = exports.PfTicketStateResource = exports.PfTicketChannelResource = exports.PfTicketProcessResource = exports.PfTicketResource = exports.PfExternalaccessResource = exports.PfDayResource = exports.PfShareResource = exports.PfCiCoResource = exports.PfTimetemplateResource = exports.PfTimeResource = exports.PfLastusedResource = exports.PfTestaccountResource = exports.PfNotificationResource = exports.PfCrmactivityResource = exports.PfContactResource = exports.PfOrganizationResource = exports.PfChatmessageResource = exports.PfChatgroupResource = exports.PfUserResource = exports.PfInterfaceResource = exports.PfDeviceResource = exports.PfIndexResource = exports.PfItemResource = exports.PfResource = void 0;
const dto_1 = require("./dto");
const apiconnection_1 = require("./apiconnection");
// declare class ApiConnection {
//   loadImageData(arg0: any): any
//   getDevice(): any 
//   deleteDTO(arg0: any): any
//   storeDTO(arg0: any, arg1: any, arg2: any): any 
//   getConnectableResource(): any
//   static createCompleteLoadUrl(arg0: any, arg1: any): any
//   loadDTO(arg0: any): any 
//   ready: any;
// };
/**
 * Die API liefert uns reines JSON (pfJSON). Die App arbeitet mit AppResourcen, die einmal das pfJSON
 * und zusätzlich für die App relevante Daten beinhalten.
 *
 * - pfJSON: RAW JSON DATA von der API
 */
class PfResource {
  constructor(_apiData) {
    this._apiData = _apiData;
    this.queryParams = {};
    this.mparams = {};
    // private _apiData:DTO; // pfJSON
    this.apiMeta = {}; //
  }
  findApiLink(relation) {
    var result = null;
    if (this._apiData._links) {
      for (var l in this._apiData._links) {
        if (this._apiData._links[l].rel == relation) {
          result = new dto_1.APILinkObject(this._apiData._links[l]);
          break;
        }
      }
    }
    return result;
  }
  get apiData() {
    return this._apiData;
  }
  set apiData(value) {
    this._apiData = value;
  }
  addQueryParam(key, value) {
    this.queryParams[key] = value;
  }
  getQueryParamsAsString() {
    var qparams = "";
    for (var key in this.queryParams) {
      if (!qparams) qparams += "?";else qparams += "&";
      if (this.queryParams.hasOwnProperty(key)) {
        qparams += key + "=" + encodeURIComponent(this.queryParams[key]);
      }
    }
    return qparams;
  }
  addMatrixParam(key, value) {
    if (this.mparams[key] && this.mparams[key] !== value) {
      this.mparams[key] = this.mparams[key] + "," + value;
    } else {
      this.mparams[key] = value;
    }
  }
  setMatrixParam(key, value) {
    this.mparams[key] = value;
  }
  getMatrixParamsAsString() {
    var mparamstmp = "";
    for (let key in this.mparams) {
      mparamstmp += ";";
      if (this.mparams.hasOwnProperty(key)) {
        mparamstmp += key + "=" + encodeURIComponent(this.mparams[key]);
      }
    }
    return mparamstmp;
  }
  /**
   * @param map
   */
  setMatrixParams(map) {
    if (!map) this.mparams = {};else this.mparams = map;
  }
  /**
   * @param map
   */
  getMatrixParams() {
    return this.mparams;
  }
  /**
   * @param map
   */
  setQueryParams(map) {
    this.queryParams = map;
  }
  /**
   * @param map
   */
  getQueryParams() {
    return this.queryParams;
  }
}
exports.PfResource = PfResource;
/**
 *
 */
class PfItemResource extends PfResource {
  constructor() {
    super(...arguments);
    this.parents = [];
  }
  getBaseUrl() {
    return null;
  }
  load(apiConnection) {
    return this._load(apiConnection, false);
  }
  loadTemplate(apiConnection) {
    return this._load(apiConnection, true);
  }
  /**
   * lädt die Resource mit der zur verfügung gestellten API-Schnittstelle
   * @param apiConnection
   * @param template
   * @return {Promise<PfItemResource>}
   */
  _load(apiConnection, template) {
    if (apiConnection) {
      return apiConnection.ready.then(() => {
        return apiConnection.loadDTO(apiconnection_1.ApiConnection.createCompleteLoadUrl(this, apiConnection.getConnectableResource(), template));
      }).then(dto => {
        this.apiData = JSON.parse(dto);
        return this;
      }).catch(err => {
        console.log("err loading resource: ", this);
        return Promise.reject(err);
      });
    } else {
      console.log("err loading resource (no apiConnection): ", this);
    }
  }
  store(apiConnection) {
    let completeUrl = apiConnection.getConnectableResource().getAPIHost() + this.getBaseUrl();
    if (this.apiData._id) completeUrl = completeUrl + "/" + this.apiData._id;
    return apiConnection.storeDTO(completeUrl, this.apiData, this.apiData._id == null).then(response => {
      this.apiData = JSON.parse(response);
      return this;
    }).catch(err => {
      console.log("err storing resource: ", this);
      return Promise.reject(err);
    });
  }
  del(apiConnection) {
    let completeUrl = apiconnection_1.ApiConnection.createCompleteLoadUrl(this, apiConnection.getDevice());
    return apiConnection.deleteDTO(completeUrl).then(response => {
      return response;
    }).catch(err => {
      console.log("err deleting resource: ", this);
      return false;
    });
  }
  additionalPrepareForCreate() {}
  /** @returns {Array<PfCollectionResource>} IndexRessourcen, indenen wir uns aktuell(Echtzeit) befinden */
  findCurrentParents() {
    return [];
  }
  /** @returns {string} */
  getAPICreateURL() {
    return this.getBaseUrl();
  }
  /** @returns {string} */
  getAPILoadURL(device) {
    if (this.apiData._url) return this.apiData._url;
    if (!this.apiData._id) return null;
    return device.getAPIHost() + this.getBaseUrl() + "/" + this.apiData._id;
  }
  getAPILoadTemplateURL(device) {
    return "";
  }
  makeAPILinkObject() {
    let apiLink = new dto_1.APILinkObject(null);
    apiLink.idKey = this.apiData._idKey;
    apiLink.href = this.apiData._url;
    apiLink.value = this.apiData._id;
    return apiLink;
    // return new APILinkObject({"href": this.apiData._url, "idKey": this.apiData._idKey, "value": this.apiData._id});
  }
  /**
   * Wir setzen Referenzen auf die Objekte der übergebenen Resource, so bleiben wir synchron
   * @param fromCachedPfResource SOLLTE AUF JEDEN FALL EIN CACHE-OBJEKT SEIN
   */
  connectDataObjects(fromCachedPfResource) {
    if (fromCachedPfResource.apiData) this.apiData = fromCachedPfResource.apiData;
    if (fromCachedPfResource.apiMeta) this.apiMeta = fromCachedPfResource.apiMeta;
    if (fromCachedPfResource.parents) this.parents = fromCachedPfResource.parents;
  }
  /**
   * Prüft pfAppRessourcen auf Gleichheit.
   * @param pfAppResource Die pfAppRessource, mit der verglichen werden sollen
   * @returns {boolean} true, wenn die UIds übereinstimmen, ansonsten false
   */
  equals(pfResource) {
    return false;
    // return pfAppResource && pfAppResource.getUId() && pfAppResource.getUId() === this.getUId();
  }
  /** @returns {string} */
  // abstract getAPICreateURL():string ;
  /**
   *
   * @param translator
   */
  prepareForCreate() {
    this.apiData = null;
    this.apiMeta.isCreate = true;
    this.parents = null;
    this.additionalPrepareForCreate();
  }
}
exports.PfItemResource = PfItemResource;
/**
 *
 */
class PfIndexResource extends PfItemResource {
  constructor(baseUrl) {
    super(new dto_1.Index());
    this.baseUrl = baseUrl;
    this.childs = [];
  }
  loadWithchilds(apiConnection, childResource, lateResolve) {
    return super.load(apiConnection).then(indexResource => {
      if (lateResolve) {
        if (childResource) {
          return this.loadChildsLateResolve(apiConnection, dto_1.PfDTO, childResource);
        }
      } else {
        if (childResource) {
          this.loadChilds(apiConnection, dto_1.PfDTO, childResource);
        }
      }
      return this;
    });
  }
  loadChilds(apiConnection, dto, resource) {
    this.childs.length = 0;
    for (let _i in this.apiData.items) {
      let cm = new dto();
      cm._url = this.apiData.items[_i].href;
      var pfitemResource = new resource(cm);
      this.childs.push(pfitemResource);
      pfitemResource.load(apiConnection).then(resource => {
        // merge schreiben
      });
    }
    return Promise.resolve(this);
  }
  loadChildsLateResolve(apiConnection, dto, resource) {
    this.childs.length = 0;
    let tmp = [];
    for (let _i in this.apiData.items) {
      let cm = new dto();
      cm._url = this.apiData.items[_i].href;
      var pfitemResource = new resource(cm);
      // this.childs.push(pfitemResource);
      tmp.push(pfitemResource.load(apiConnection)); //.then((resource:PfItemResource<DTO>) => {
    }
    return Promise.all(tmp).then(arrayLoadedRsources => {
      for (let _i in arrayLoadedRsources) {
        this.childs.push(arrayLoadedRsources[_i]);
      }
      return this;
    });
    // return Promise.resolve(this);
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  getBaseTemplateUrl() {
    return this.baseUrl + "/meta/template";
  }
  makeAPILinkObject() {
    return new dto_1.APILinkObject({
      "href": this.apiData._url
    });
  }
  getAPILoadURL(device) {
    if (this.apiData._url) return this.apiData._url;
    return device.getAPIHost() + this.getBaseUrl();
  }
  getAPILoadTemplateURL(device) {
    return this.getAPILoadURL(device) + "/meta/template";
  }
  /**
   * Prüft pfAppRessourcen auf Gleichheit. (Not implemented yet)
   * @param pfAppResource Die pfAppRessource, mit der verglichen werden sollen
   * @returns {boolean}
   */
  equals(pfAppResource) {
    return false;
    // return pfAppResource && ((pfAppResource.getUId() && pfAppResource.getUId() === this.getUId()) || (pfAppResource.getAppLoadURL() && pfAppResource.getAppLoadURL() === this.getAppLoadURL()));
  }
}
exports.PfIndexResource = PfIndexResource;
class PfDeviceResource extends PfItemResource {
  /**
   * kann zum reconncet genutzt werden
   * @param apiConnection
   */
  connect(apiConnection) {
    //Token sichern...
    var token = this.getToken();
    //...Device updaten
    return apiConnection.loadDTO(this.apiData._url).then(loadedDeviceString => {
      this.apiData = JSON.parse(loadedDeviceString);
      this.apiData.token = token;
      return this;
    });
  }
  getBaseUrl() {
    return "/device";
  }
  getAPIHost() {
    return this.apiData.apiHost;
  }
  getToken() {
    return this.apiMeta.token || this.apiData.token || null;
  }
  setToken(token) {
    this.apiData.token = token;
    // hier ist es sicher von server updates
    this.apiMeta.token = token;
  }
}
exports.PfDeviceResource = PfDeviceResource;
class PfInterfaceResource extends PfItemResource {
  /**
   * kann zum reconncet genutzt werden
   * @param apiConnection
   */
  connect(apiConnection) {
    //...Device updaten
    return apiConnection.loadDTO(this.apiData._url).then(loadedInterfceString => {
      this.apiData = JSON.parse(loadedInterfceString);
      return this;
    });
  }
  getBaseUrl() {
    return "/interface";
  }
  getAPIHost() {
    return this.apiData.apiHost;
  }
}
exports.PfInterfaceResource = PfInterfaceResource;
class PfUserResource extends PfItemResource {
  getBaseUrl() {
    return "/user";
  }
  makeAPILinkObject() {
    let apiLink = super.makeAPILinkObject();
    apiLink.caption = this.apiData.caption;
    return apiLink;
  }
  loadUserImage(apiConnection) {
    // Ziel ist der ImageDescriptor
    if (!this.userImage) {
      this.userImage = new dto_1.ImageInlineData();
    }
    // Laden oder nullen?
    if (this.apiData.image && this.apiData.image.href) {
      this.userImage.href = this.apiData.image.href;
      return apiConnection.loadImageData(this.userImage);
    } else {
      this.userImage.href = null;
      this.userImage.src = null;
      return Promise.resolve(this.userImage);
    }
  }
  loadUserBackgroundImage(apiConnection) {
    // Ziel ist der ImageDescriptor
    if (!this.userBackground) {
      this.userBackground = new dto_1.ImageInlineData();
    }
    // Laden oder nullen?
    if (this.apiData.background && this.apiData.background.href) {
      this.userBackground.href = this.apiData.background.href;
      return apiConnection.loadImageData(this.userBackground);
    } else {
      this.userBackground.href = null;
      this.userBackground.src = null;
      return Promise.resolve(this.userBackground);
    }
  }
  get userImage() {
    return this._userImage;
  }
  set userImage(value) {
    this._userImage = value;
  }
  get userBackground() {
    return this._userBackground;
  }
  set userBackground(value) {
    this._userBackground = value;
  }
}
exports.PfUserResource = PfUserResource;
class PfChatgroupResource extends PfItemResource {
  getBaseUrl() {
    return "/chatgroup";
  }
  makeAPILinkObject() {
    let apiLink = super.makeAPILinkObject();
    apiLink.caption = this.apiData.name;
    return apiLink;
  }
  isdefaultGroup() {
    if (this.apiData && this.apiData._id && !this.apiData.name) {
      return true;
    } else {
      return false;
    }
  }
}
exports.PfChatgroupResource = PfChatgroupResource;
class PfChatmessageResource extends PfItemResource {
  getBaseUrl() {
    return "/chatmessage";
  }
}
exports.PfChatmessageResource = PfChatmessageResource;
class PfOrganizationResource extends PfItemResource {
  getBaseUrl() {
    return "/organization";
  }
  makeAPILinkObject(relation) {
    let apiLink = super.makeAPILinkObject();
    apiLink.caption = this.apiData.name;
    return apiLink;
  }
}
exports.PfOrganizationResource = PfOrganizationResource;
class PfContactResource extends PfItemResource {
  getBaseUrl() {
    return "/contact";
  }
  makeAPILinkObject(relation) {
    let apiLink = super.makeAPILinkObject();
    apiLink.caption = this.apiData.caption;
    return apiLink;
  }
}
exports.PfContactResource = PfContactResource;
class PfCrmactivityResource extends PfItemResource {
  getBaseUrl() {
    return "/crmactivity";
  }
}
exports.PfCrmactivityResource = PfCrmactivityResource;
class PfNotificationResource extends PfItemResource {
  getBaseUrl() {
    return "/notification";
  }
}
exports.PfNotificationResource = PfNotificationResource;
class PfTestaccountResource extends PfItemResource {
  getBaseUrl() {
    return "/testaccount";
  }
}
exports.PfTestaccountResource = PfTestaccountResource;
class PfLastusedResource extends PfItemResource {
  constructor(lu, userId) {
    super(lu);
    this.userId = userId;
  }
  getBaseUrl() {
    return this.userId ? "/user/" + this.userId + "/lastused" : "/lastused";
  }
}
exports.PfLastusedResource = PfLastusedResource;
class PfTimeResource extends PfItemResource {
  getBaseUrl() {
    return "/time";
  }
}
exports.PfTimeResource = PfTimeResource;
class PfTimetemplateResource extends PfItemResource {
  getBaseUrl() {
    return "/timetemplate";
  }
}
exports.PfTimetemplateResource = PfTimetemplateResource;
class PfCiCoResource extends PfItemResource {
  getBaseUrl() {
    return "/cico";
  }
}
exports.PfCiCoResource = PfCiCoResource;
/*export class PfInterfaceResource extends PfItemResource<Interface> {
  getBaseUrl(): string {
    return "/interface";
  }

  getAPIHost() :string {
    return this.apiData.apiHost;
  }
}*/
class PfShareResource extends PfItemResource {
  getBaseUrl() {
    return "/share";
  }
  /** @returns {string} */
  getAPILoadURL(device) {
    if (this.apiData._url) return this.apiData._url;
    if (!this.shareid) return null;
    return device.getAPIHost() + this.getBaseUrl() + "/" + this.shareid;
  }
}
exports.PfShareResource = PfShareResource;
class PfDayResource extends PfItemResource {
  getBaseUrl() {
    return "/day";
  }
}
exports.PfDayResource = PfDayResource;
class PfExternalaccessResource extends PfItemResource {
  getBaseUrl() {
    return "/externalaccess";
  }
}
exports.PfExternalaccessResource = PfExternalaccessResource;
class PfTicketResource extends PfItemResource {
  getBaseUrl() {
    return '/ticket';
  }
}
exports.PfTicketResource = PfTicketResource;
class PfTicketProcessResource extends PfItemResource {
  getBaseUrl() {
    return '/ticketprocess';
  }
}
exports.PfTicketProcessResource = PfTicketProcessResource;
class PfTicketChannelResource extends PfItemResource {
  getBaseUrl() {
    return '/ticketchannel';
  }
}
exports.PfTicketChannelResource = PfTicketChannelResource;
class PfTicketStateResource extends PfItemResource {
  getBaseUrl() {
    return '/ticketstate';
  }
}
exports.PfTicketStateResource = PfTicketStateResource;
class PfProjectResource extends PfItemResource {
  getBaseUrl() {
    return '/project';
  }
}
exports.PfProjectResource = PfProjectResource;
class PfInvoiceResource extends PfItemResource {
  getBaseUrl() {
    return '/invoice';
  }
}
exports.PfInvoiceResource = PfInvoiceResource;
class PfProjecthistoryResource extends PfItemResource {
  getBaseUrl() {
    return '/projecthistory';
  }
}
exports.PfProjecthistoryResource = PfProjecthistoryResource;
class PfFileResource extends PfItemResource {
  getBaseUrl() {
    return '/file';
  }
  getDataUrl() {
    return '/data';
  }
}
exports.PfFileResource = PfFileResource;
class PfAttendancecategoryResource extends PfItemResource {
  getBaseUrl() {
    return '/attendancecategory';
  }
}
exports.PfAttendancecategoryResource = PfAttendancecategoryResource;
